var _defs, _g, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #28aee4;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        stroke: #134d65;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.94,70.11V23.78c0-2.3-1.87-4.17-4.17-4.17h-57.91c-2.3,0-4.17,1.87-4.17,4.17v76.7c0,2.3,1.87,4.17,4.17,4.17h29.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.63,43.54c3.67,0,6.65-2.98,6.65-6.65s-2.98-6.66-6.65-6.66-6.65,2.98-6.65,6.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.63,62.93c3.67,0,6.65-2.98,6.65-6.65s-2.98-6.66-6.65-6.66-6.65,2.98-6.65,6.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.67,
    y1: 63.93,
    x2: 36.18,
    y2: 63.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.67,
    y1: 76.02,
    x2: 36.18,
    y2: 76.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.67,
    y1: 88.1,
    x2: 36.18,
    y2: 88.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.83,73.58v11.23h-52.07v-11.23c0-1.92,1.6-3.47,3.57-3.47h44.93c1.97,0,3.57,1.55,3.57,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.83,84.81v36.1c0,1.92-1.61,3.48-3.57,3.48h-44.93c-1.98,0-3.57-1.55-3.57-3.48v-36.1h52.07Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.28,
    y1: 91.31,
    x2: 71.96,
    y2: 98.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.28,
    y1: 98.42,
    x2: 71.96,
    y2: 91.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.26,
    y1: 94.87,
    x2: 96.91,
    y2: 94.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.79,
    y1: 111.74,
    x2: 70.44,
    y2: 111.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.79,
    y1: 116.76,
    x2: 70.44,
    y2: 116.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.26,
    y1: 114.25,
    x2: 96.91,
    y2: 114.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.08,
    y1: 119.28,
    x2: 102.08,
    y2: 109.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 88.81,
    y1: 84.79,
    x2: 88.81,
    y2: 124.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.75,
    y1: 104.57,
    x2: 114.88,
    y2: 104.57
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.5,
    y: 34.28,
    width: 14.01,
    height: 17.43
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.49,
    y: 39.76,
    width: 14.01,
    height: 11.95,
    transform: "translate(118.99 91.47) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.48,
    y: 28.3,
    width: 14.01,
    height: 23.41,
    transform: "translate(84.97 80.01) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.b3899657996db5592e40b88707c815c8.svg";
export { ForwardRef as ReactComponent };